export const isValidEmail = (string) => {
  return /^.+@.+\..+$/.test(string);
}
